// extracted by mini-css-extract-plugin
export default {"balance":"Home_balance_CJEIm","refill":"Home_refill_n2rCA","limit":"Home_limit_P80Hb","linkButtons":"Home_linkButtons_iYlNJ","buttonLink":"Home_buttonLink_pNpmZ"};